import(/* webpackMode: "eager" */ "/home/ubuntu/download/69847c45921dc90014b3fc71/apollobits_academy/src/app/landing/page.tsx");
